import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Button from 'products/nomad_insurance/components/Button';
import BaseModal from 'products/nomad_insurance/components/BaseModal';
import Feedback from 'products/nomad_insurance/components/Feedback';
import { ButtonsContainer, Paragraph, FeedbackWrapper } from './styled';

const DeleteClaimConfirmation = ({ isOpen, onClose, onConfirmation }) => {
  const { deleteClaimError } = useSelector(
    (state) => state.nomadInsurance.profile.claims
  );

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      heading="Are you sure you want to delete your claim?"
      headerColor="porsche"
    >
      <Paragraph>Once deleted, your draft claim cannot be recovered.</Paragraph>

      {deleteClaimError && (
        <FeedbackWrapper>
          <Feedback variant="failure">
            Something went wrong with claim deletion. Please try again later.
          </Feedback>
        </FeedbackWrapper>
      )}

      <ButtonsContainer>
        <Button onClick={onClose} variant="textOnly" color="pickledBluewood">
          Nevermind
        </Button>
        <Button onClick={onConfirmation} color="fuzzyWuzzyBrown">
          Yes, delete my claim
        </Button>
      </ButtonsContainer>
    </BaseModal>
  );
};

DeleteClaimConfirmation.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirmation: PropTypes.func
};

export default DeleteClaimConfirmation;
